import Promise from 'bluebird';
import { handleActions } from 'redux-actions';
import http from '../shared/http';
import endpoints from '../../config/endpoints';
import cloneDeep from 'lodash/cloneDeep';
import intl from '../shared/intl';

import first from 'lodash/first';
import flatten from 'lodash/flatten';
import values from 'lodash/values';
import keys from 'lodash/keys';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import get from 'lodash/get';
import { actions as httpActions } from './../shared/http';

import { replace } from 'react-router-redux';

import moment from 'moment';

import checkPermissions from '../shared/check-permissions';
import allowedPermissions from '../sidebar/permissions';
import localStorageManger from '../shared/local-storage';

import { create as createPolling } from '../../../../shared/js/intervals';
import { enum as permissionsEnum } from '../../../../../enums/admin-permissions';
import {SubmissionError} from 'redux-form';

const unreadPostsPolling = createPolling('root', {
	fetchUnreadPosts: { interval: 2 * 60000 } // 2 minutes
});

const needToUpdatePolling = createPolling('root', {
	fetchNeedToUpdate: { interval: 10000 }
});

const unreadExtPostsPolling = createPolling('root', {
	fetchUnreadExtPosts: { interval: 5 * 60000 } // 5 minutes
});

const debtPolling = createPolling('root', {
	fetchDebt: { interval: 30000 }
});

const payoutRequestsPolling = createPolling('root', {
	fetchPayoutRequests: { interval: 10000 }
});

// actions types
const FETCH_NOT_STORE_AFFECT_SUCCESS = 'root/fetch-not-store-affect-success';
const FETCH_DATA_SUCCESS = 'root/fetch-data-success';
const FETCH_DATA_ERROR = 'root/fetch-data-error';

const FETCH_UNREAD_POSTS_SUCCESS = 'root/fetch-unread-posts-success';
const FETCH_UNREAD_POSTS_ERROR = 'root/fetch-unread-posts-error';

const FETCH_NEED_TO_UPDATE_CHAINS_SUCCESS = 'root/fetch-need-to-update-chains-success';
const FETCH_NEED_TO_UPDATE_CHAINS_ERROR = 'root/fetch-need-to-update-chains-error';

const FETCH_PAYOUT_REQUEST_OK = 'root/FETCH_PAYOUT_REQUEST_OK';
const FETCH_PAYOUT_REQUEST_ERR = 'root/FETCH_PAYOUT_REQUEST_ERR';

const FETCH_DEBT_UPDATE_SUCCESS = 'root/fetch-debt-update-success';
const FETCH_DEBT_UPDATE_ERROR = 'root/fetch-debt-update-error';

const LOGIN_SUCCESS = 'root/login-success';
const LOGIN_ERROR = 'root/login-error';

const LOGOUT_SUCCESS = 'root/logout-success';
const LOGOUT_ERROR = 'root/logout-error';

const MENU_TOGGLE = 'root/menu-toggle';
const SPINNER_TOGGLE = 'root/spinner-toggle';

const SET_DATA_TO_LOCAL_STORE = `root/set-data-to-local-store`;

const REFETCH_SAVED_FILTERS_SUCCESS = 'root/refetch-saved-filters-success';
const REFETCH_SAVED_FILTERS_ERROR = 'root/refetch-saved-filters-error';

const ls = localStorageManger('localData');

// initial state
const initialState = {
	data: null,
	shouldLogin: null,
	shouldShowLoadingSpinner: false,
	currentLang: 'en',
	menu: {
		isOpen: true,
		// [1,2] first value is menu item index, second is submenu item index
		activeItem: []
	},
	unreadThreadPostsCount: 0,
	needToUpdateChainsCount: 0,
	payoutRequestsCount: 0,
	unreadExtThreadPostsCount: 0,
	shouldStopUnreadPolling: false,
	shouldStopExtUnreadPolling: false,
	lists: null,
	localData: null,
	error: false
};

const initialDebt = [
	{amount: '', currency: 'rub', type: 'debt'},
	{amount: '', currency: 'usd', type: 'debt'}
];

const dataToFetch = {
	data: endpoints.AUTH,
	lists: endpoints.LISTS.ALL,
	savedFilters: `${endpoints.ADMIN_PROFILE}/saved-filters`,
	globalConfig: `${endpoints.LISTS.ALL}/global-config`
};

const isRocket = process.env.CPA_ENV === 'rocket';

// actions
export const actions = {
	fetchData: () => dispatch => {
		const request = http({
			url: values(dataToFetch),
			method: 'get',
			actions: [FETCH_NOT_STORE_AFFECT_SUCCESS, FETCH_DATA_ERROR]
		});
		return request(dispatch).then(async action => {
			if (action.type === FETCH_NOT_STORE_AFFECT_SUCCESS) {
				const data = action.payload.map(entity => entity.data);
				window.globalConfig = data[3];

				if (process.env.CPA_ENV === 'everad' && process.env.NODE_ENV === 'production') {
					Rollbar && Rollbar.configure({
						payload: { person: { id: data[0].id } }
					});
				}

				const { permissions, timezone } = data[0];
				moment.tz.setDefault(timezone);
				if (permissions.indexOf(permissionsEnum.totalDebtView) > -1 || isRocket) {
					await dispatch(actions.fetchDebtUpdate());
				}

				if (
					permissions.indexOf(permissionsEnum.threadsList) === -1 &&
					permissions.indexOf(permissionsEnum.extThreadsList) === -1
				) {
					dispatch({
						type: FETCH_DATA_SUCCESS,
						payload: reduceDataToObject(data)
					});
				}

				dispatch(actions.fetchUpdates(action, data));
			}
			return action;
		});
	},

	fetchUpdates: (action, data) => dispatch => {
		const permissions = data[0].permissions;
		const promises = [];
		const baseReqConfig = {
			method: 'get',
			actions: [FETCH_NOT_STORE_AFFECT_SUCCESS, FETCH_UNREAD_POSTS_ERROR]
		};

		if (permissions.indexOf(permissionsEnum.threadsList) !== -1) {
			promises.push(
				http({ ...baseReqConfig, url: endpoints.THREADS.UNREAD_COUNT, addToResponse: 'threads' })(dispatch)
			);
		}

		if (permissions.indexOf(permissionsEnum.extThreadsList) !== -1) {
			promises.push(
				http({ ...baseReqConfig, url: endpoints.EXTERNAL_THREADS.UNREAD_COUNT, addToResponse: 'ext_threads' })(dispatch)
			);
		}

		if (permissions.indexOf(permissionsEnum.payoutRequestsViewPersonal) !== -1) {
			promises.push(
				http({
					...baseReqConfig, url: endpoints.PAYOUT_REQUESTS.COUNT, addToResponse: 'payout_requests'
				})(dispatch)
			);
		}

		if (permissions.indexOf(permissionsEnum.chainsView) !== -1) {
			promises.push(
				http({
					...baseReqConfig,
					url: endpoints.CHAINS.NEED_TO_UPDATE_COUNT,
					addToResponse: 'not_updated_chains'
				})(dispatch)
			);
		}

		Promise.map(promises, action => {
			let result = {};
			switch (action.meta) {
				case 'threads':
					result.threadsUnread = action.payload.data;
					unreadPostsPolling.actions.start(
						'root',
						'fetchUnreadPosts',
						actions.fetchUnreadPosts(),
						dispatch
					);
					return result;
				case 'payout_requests':
					result.payoutRequests = action.payload.data;
					payoutRequestsPolling.actions.start(
						'root',
						'fetchPayoutRequests',
						actions.fetchPayoutRequests(),
						dispatch
					);
					return result;
				case 'not_updated_chains':
					result.notUpdatedChains = action.payload.data;
					needToUpdatePolling.actions.start(
						'root',
						'fetchNeedToUpdate',
						actions.fetchNeedToUpdateChains(),
						dispatch
					);
					return result;
				default:
					result.extThreadsUnread = action.payload.data;
					unreadExtPostsPolling.actions.start(
						'root',
						'fetchUnreadExtPosts',
						actions.fetchUnreadPosts('external'),
						dispatch
					);
					return result;
			}
		}).then(updates => {
			let payload = reduceDataToObject(data);

			updates.forEach(update => {
				payload = { ...payload, ...update };
			});

			dispatch({ type: FETCH_DATA_SUCCESS, payload });

			if (permissions.indexOf(permissionsEnum.totalDebtView) > -1 || isRocket) {
				debtPolling.actions.start(
					'root', 'fetchDebt', actions.fetchDebtUpdate(), dispatch
				);
			}

		});
	},

	fetchNeedToUpdateChains: () => dispatch => {
		http({
			url: endpoints.CHAINS.NEED_TO_UPDATE_COUNT,
			method: 'get',
			actions: [FETCH_NEED_TO_UPDATE_CHAINS_SUCCESS, FETCH_NEED_TO_UPDATE_CHAINS_ERROR]
		})(dispatch);
	},

	fetchPayoutRequests: () => dispatch => {
		http({
			url: endpoints.PAYOUT_REQUESTS.COUNT,
			method: 'get',
			actions: [FETCH_PAYOUT_REQUEST_OK, FETCH_PAYOUT_REQUEST_ERR]
		})(dispatch);
	},

	fetchUnreadPosts: type => (dispatch, getState) => {
		const { shouldStopExtUnreadPolling, shouldStopUnreadPolling } = getState().root;
		const shouldStop = type === 'external' ? shouldStopExtUnreadPolling : shouldStopUnreadPolling;

		if (!shouldStop) {
			http({
				url: type === 'external' ? `${endpoints.EXTERNAL_THREADS.UNREAD_COUNT}` : `${endpoints.THREADS.UNREAD_COUNT}`,
				method: 'get',
				actions: [FETCH_UNREAD_POSTS_SUCCESS, FETCH_UNREAD_POSTS_ERROR],
				addToResponse: type
			})(dispatch);
		} else {
			if (type === 'external') {
				unreadExtPostsPolling.actions.stop('root', 'fetchUnreadExtPosts');
			} else {
				unreadPostsPolling.actions.stop('root', 'fetchUnreadPosts');
			}
		}
	},

	login: data => dispatch => {
		const request = http({
			url: endpoints.AUTH,
			method: 'put',
			actions: [LOGIN_SUCCESS, LOGIN_ERROR],
			data
		});
		return request(dispatch).then(action => {
			if (action.type === LOGIN_SUCCESS) {
				dispatch(actions.fetchData()).then(action => {
					if (action.type === FETCH_DATA_SUCCESS) {
						dispatch(replace('/statistics'));
					}
				});
			}
			if (action.type === LOGIN_ERROR ) {
				let responseError;
				if (get(action, 'payload.response.status') === 400) {
					responseError = get(action, 'payload.response.data.message', 'Unknown error');
				} else {
					responseError = JSON.stringify(get(action, 'payload.response.data', 'Unknown error'));
				}

				throw new SubmissionError({
					_error: responseError
				});
			}
			return action;
		});
	},

	logout: () => dispatch => {
		const request = http({
			url: endpoints.AUTH,
			method: 'delete',
			actions: [LOGOUT_SUCCESS, LOGOUT_ERROR]
		});

		request(dispatch).then(action => {
			if (action.type === LOGOUT_SUCCESS) {
				window.location.href = process.env.CPA_ENV === 'everad' ? '//everad.com' : '//rocketprofit.com';
			}
		});
	},

	menuToggle: () => ({
		type: MENU_TOGGLE
	}),

	spinnerToggle: () => ({
		type: SPINNER_TOGGLE
	}),

	removeApiErrors: () => dispatch => dispatch(httpActions.removeApiErrors()),

	setLocalData: (key, value) => (dispatch, getState) => {
		const { data: { id } } = getState().root;
		ls.setData(id)(key, value);
		dispatch({
			type: SET_DATA_TO_LOCAL_STORE,
			payload: ls.values(id)
		});
	},

	refetchSavedFilters: () => dispatch => {
		return http({
			url: `${endpoints.ADMIN_PROFILE}/saved-filters`,
			method: 'get',
			actions: [REFETCH_SAVED_FILTERS_SUCCESS, REFETCH_SAVED_FILTERS_ERROR]
		})(dispatch);
	},

	fetchDebtUpdate: () => dispatch => {
		return http({
			url: endpoints.AFFILIATES.TOTAL_DEBT,
			method: 'get',
			actions: [FETCH_DEBT_UPDATE_SUCCESS, FETCH_DEBT_UPDATE_ERROR]
		})(dispatch);
	}
};

// reducers
export default handleActions(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => {
			const {
				data, lists, savedFilters, threadsUnread, extThreadsUnread, notUpdatedChains, payoutRequests
			} = action.payload;
			const currentLang = first(data.languages);

			return {
				...state,
				data,
				lists,
				currentLang,
				unreadThreadPostsCount: threadsUnread
					? parseInt(threadsUnread['new_posts'])
					: state.unreadThreadPostsCount,
				needToUpdateChainsCount: notUpdatedChains
					? parseInt(notUpdatedChains['need_update'])
					: state.needToUpdateChainsCount,
				payoutRequestsCount: payoutRequests
					? parseInt(payoutRequests)
					: state.payoutRequestsCount,
				unreadExtThreadPostsCount: extThreadsUnread
					? parseInt(extThreadsUnread['new_posts'])
					: state.unreadExtThreadPostsCount,
				localData: ls.values(data.id),
				savedFilters
			};
		},

		[FETCH_UNREAD_POSTS_SUCCESS]: (state, action) => {
			const isExternal = action.meta && action.meta === 'external';
			const threadsUnreadCount = action.payload.data;
			const currentUnreadCount = isExternal ? state.unreadExtThreadPostsCount : state.unreadThreadPostsCount;
			return {
				...state,
				[isExternal ? 'unreadExtThreadPostsCount' : 'unreadThreadPostsCount']: threadsUnreadCount
					? parseInt(threadsUnreadCount['new_posts'])
					: currentUnreadCount
			};
		},

		[FETCH_NEED_TO_UPDATE_CHAINS_SUCCESS]: (state, action) => ({
			...state,
			needToUpdateChainsCount: parseInt(get(action, ['payload', 'data', 'need_update'], 0))
		}),

		[FETCH_PAYOUT_REQUEST_OK]: (state, action) => ({
			...state,
			payoutRequestsCount: parseInt(get(action, ['payload', 'data'], 0))
		}),

		[FETCH_NEED_TO_UPDATE_CHAINS_ERROR]: state => ({ ...state, error: true }),

		[FETCH_DATA_ERROR]: (state, action) => {
			const { status } = action.payload.response;
			if (status === 403) {
				return { ...state, shouldLogin: true };
			}
			return { ...state, error: true };
		},

		[FETCH_UNREAD_POSTS_ERROR]: (state, action) => {
			const isExternal = get(action, 'payload.response.config.url', '').indexOf('external-threads') > 0;
			const status = get(action, 'payload.response.status');
			if (status === 403) {
				return {
					...state,
					[isExternal ? 'shouldStopExtUnreadPolling' : 'shouldStopUnreadPolling']: true
				};
			}
			return state; //do not crash app on background process result
		},

		[FETCH_DEBT_UPDATE_SUCCESS]: (state, action) => ({
			...state,
			error: false,
			debt: action.payload.data
		}),

		[FETCH_DEBT_UPDATE_ERROR]: state => ({ ...state, error: true }),

		[MENU_TOGGLE]: state => ({
			...state,
			menu: {
				...state.menu,
				isOpen: !state.menu.isOpen
			}
		}),

		[SPINNER_TOGGLE]: state => ({
			...state,
			shouldShowLoadingSpinner: !state.shouldShowLoadingSpinner
		}),

		[SET_DATA_TO_LOCAL_STORE]: (state, action) => ({
			...state,
			localData: action.payload
		}),

		[REFETCH_SAVED_FILTERS_SUCCESS]: (state, action) => ({
			...state,
			savedFilters: action.payload.data
		}),

		[REFETCH_SAVED_FILTERS_ERROR]: state => ({
			...state,
			savedFilters: initialState.savedFilters
		})
	},
	cloneDeep(initialState)
);

// selectors
export const selectors = {
	getData: state => state.root.data,
	getAvailableCurrencies: state => state.root.lists && state.root.lists['available-currencies'],
	getDebt: state => {
		if (!state.root.data) return null;
		let debt = state.root.debt ? state.root.debt : initialDebt;

		const currencies = state.root.lists['available-currencies'];
		const groupByType = groupBy(debt, 'type');

		const calculateOnBalance = groupByType['debt'].map(entity => {
			const payoutByDeptCurrency = find(groupByType['payouts'], { currency: entity.currency });
			return {
				...entity,
				amount: payoutByDeptCurrency ? entity.amount - payoutByDeptCurrency.amount : entity.amount,
				type: 'onBalance'
			};
		});

		const composedData = {
			...groupByType,
			onBalance: calculateOnBalance
		};

		const points = find(composedData['debt'], { currency: 'points' });
		return currencies.reduce(
			(acc, currentValue) => ({
				...acc,
				[currentValue.id]: {
					debt: find(composedData['debt'], { currency: currentValue.id }),
					payouts: find(composedData['payouts'], { currency: currentValue.id }),
					onBalance: find(composedData['onBalance'], { currency: currentValue.id })
				}
			}),
			{
				points: {
					debt: points,
					payouts: null,
					onBalance: points
				}
			}
		);
	},
	getError: state => state.root.error,
	getApiErrors: state => state.apiErrors,
	getMenuConfig: state => state.root.data && getMenuConfig(state),
	getShouldLogin: state => state.root.shouldLogin,
	getShouldShowLoadingSpinner: state => state.root.shouldShowLoadingSpinner,
	getIntl: state => intl(state)
};

// functions
const getMenuConfig = state => {
	const can = checkPermissions(state, allowedPermissions);

	const menuItems = [
		{
			icon: 'showcase',
			title: 'Showcase',
			uri: 'showcase/',
			shouldShow: process.env.NODE_ENV === 'development'
		},
		{
			icon: 'statistics',
			title: 'Statistics',
			index: 'statistics',
			uri: 'statistics/',
			hasNestedItems: isRocket
				? (can('topAffiliatesViewAll') || can('topOffersViewAll'))
				: (can('viewAffiliates') || can('affiliateIdsList') || can('viewPrograms')),
			shouldShow: can('viewAnalytics')
		},
		{
			icon: 'affiliates',
			title: 'Top affiliates',
			uri: 'top-affiliates/',
			nestedFromIndex: 'statistics',
			shouldShow: isRocket
				? can('topAffiliatesViewAll')
				: (can('viewAffiliates') || can('affiliateIdsList'))
		},
		{
			icon: 'programs',
			title: 'Top offers',
			uri: 'top-offers/',
			nestedFromIndex: 'statistics',
			shouldShow: isRocket ? can('topOffersViewAll') : can('viewPrograms')
		},
		{
			icon: 'affiliates',
			title: 'Top countries',
			uri: 'top-countries/',
			nestedFromIndex: 'statistics',
			shouldShow: isRocket ? can('topOffersViewAll') : can('viewPrograms')
		},
		{
			icon: 'payouts',
			title: 'Payouts',
			shouldShow: can('viewPayouts'),
			uri: 'payouts/'
		},
		{
			icon: 'affiliates',
			title: 'Affiliates',
			uri: 'affiliates/',
			shouldShow: can('viewAffiliates') || can('affiliateIdsList')
		},
		{
			icon: 'affiliates-activity',
			title: 'Affiliates activity',
			uri: 'affiliates-activity/',
			shouldShow: can('viewAffiliatesActivity')
		},
		{
			icon: 'affiliates-redeem',
			title: 'Affiliates redeem',
			uri: 'affiliates-redeem/',
			shouldShow: can('viewAffiliatesRedeem')
		},
		{
			icon: 'affiliates-redeem',
			title: 'Payout requests',
			uri: 'payout-requests/',
			shouldShow: can('viewPersonalPayoutRequests'),
			iconCount: state.root.payoutRequestsCount
		},
		{
			icon: 'requests',
			title: 'Garants',
			uri: 'conversions-approve-requests/',
			shouldShow: can('viewConversionsApprove')
				|| can('viewConversionsApproveRequests')
				|| can('garantApproveRequestsView')
				|| can('garantForecastView')
				|| can('guarantRegisterView'),
			subitems: [
				{
					icon: 'codes-a',
					title: 'Conversions approve',
					uri: 'conversions-approve/',
					shouldShow: can('viewConversionsApprove')
				},
				{
					icon: 'codes-a',
					title: 'Conversions approve requests',
					uri: 'conversions-approve-requests/',
					shouldShow: can('viewConversionsApproveRequests')
				},
				{
					icon: 'codes-a',
					title: 'Conversions garant requests',
					uri: 'conversions-garant-approve-requests/',
					shouldShow: can('garantApproveRequestsView')
				},
				{
					icon: 'codes-a',
					title: 'Limited garants',
					uri: 'limited-garants/',
					shouldShow: can('guarantRegisterView')
				},
				{
					icon: 'codes-a',
					title: 'Guarant approve register',
					uri: 'guarant-approve-requests/',
					shouldShow: can('guarantRegisterView')
				},
				{
					icon: 'codes-a',
					title: 'Garant forecast',
					uri: 'garant-forecast/',
					shouldShow: can('garantForecastView')
				}
			]
		},
		{
			icon: 'affiliates-redeem',
			title: 'Manager reports',
			uri: 'affiliate-managers-productivity/',
			shouldShow: can('affiliateManagersProductivityListAll') || can('affiliateManagersProductivityShowMe') ||
				can('managersAffiliatesActivity') ||
				can('trafficAccountingView') ||
				can('alertsAnalytics') ||
				can('registrationAnalytics') ||
				can('marketingFunnel') ||
				can('conversionsApproveDaily') ||
				can('priorities') ||
				can('productCap') ||
				can('weeklyReport') ||
				can('quidsReport'),
			subitems: [{
				icon: 'affiliates-redeem',
				title: 'Productivity',
				uri: 'affiliate-managers-productivity/',
				shouldShow: can('affiliateManagersProductivityListAll') || can('affiliateManagersProductivityShowMe')
			}, {
				icon: 'affiliates-redeem',
				title: 'Activity',
				uri: 'managers-affiliates-activity/',
				shouldShow: can('managersAffiliatesActivity')
			}, {
				icon: 'affiliates-redeem',
				title: 'Traffic Accounting',
				uri: 'traffic-accounting/',
				shouldShow: can('trafficAccountingView')
			}, {
				icon: 'affiliates-redeem',
				title: 'Alerts analytics',
				uri: 'alerts-analytics/',
				shouldShow: can('alertsAnalytics')
			}, {
				icon: 'affiliates-redeem',
				title: 'Registration analytics',
				uri: 'registration-analytics/',
				shouldShow: can('registrationAnalytics')
			}, {
				icon: 'affiliates-redeem',
				title: 'Marketing funnel',
				uri: 'marketing-funnel/',
				shouldShow: can('marketingFunnel')
			}, {
				icon: 'affiliates-redeem',
				title: 'Daily approves list',
				uri: 'daily-approves-list/',
				shouldShow: can('conversionsApproveDaily')
			}, {
				icon: 'affiliates-redeem',
				title: 'Priorities',
				uri: 'priorities/',
				shouldShow: can('priorities')
			}, {
				icon: 'affiliates-redeem',
				title: 'Product Cap',
				uri: 'product-cap/',
				shouldShow: can('productCap')
			}, {
				icon: 'affiliates-redeem',
				title: 'Weekly report',
				uri: 'weekly-report/',
				shouldShow: can('weeklyReport')
			}, {
				icon: 'affiliates-redeem',
				title: 'Quids report',
				uri: 'quids-report/',
				shouldShow: can('quidsReport')
			}]
		},
		{
			icon: 'support',
			title: 'Support',
			uri: 'threads/',
			shouldShow: can('viewThreads'),
			iconCount: state.root.unreadThreadPostsCount
		},
		{
			icon: 'programs',
			title: 'Offers',
			uri: 'programs/',
			shouldShow: can('viewPrograms')
		},
		{
			icon: 'requests',
			title: 'Requests',
			iconCount: state.root.unreadExtThreadPostsCount,
			shouldShow:
				can('viewExtThreads') ||
				can('viewAdvRequests'),
			subitems: [
				{
					icon: 'web-request',
					title: 'Ext. requests',
					uri: 'external-tickets/',
					shouldShow: can('viewExtThreads'),
					iconCount: state.root.unreadExtThreadPostsCount
				},
				{
					icon: 'adv-request',
					title: 'Adv. requests',
					uri: 'adv-requests/',
					shouldShow: can('viewAdvRequests')
				}
			]
		},
		{
			icon: 'marketing',
			title: 'Marketing',
			shouldShow:
				can('viewNews') ||
				can('viewMailings') ||
				can('viewPolls') ||
				(can('viewDiscounts') && !isRocket) ||
				(can('missionsView') && !isRocket) ||
				can('viewGoods') ||
				can('viewBmAccounts') ||
				can('viewMarketingReports') ||
				(can('viewRanksPointsReport') && isRocket) ||
				can('banners') ||
				(can('popups') && isRocket) ||
				(can('blog') && isRocket) ||
				can('contestView'),
			subitems: [
				{
					icon: 'news',
					title: 'News',
					uri: 'news/',
					shouldShow: can('viewNews')
				},
				{
					icon: 'mails',
					title: 'Mailings',
					uri: 'mailings-new/',
					shouldShow: can('viewMailings')
				},
				{
					icon: 'polls',
					title: 'Polls',
					uri: 'polls/',
					shouldShow: can('viewPolls')
				},
				{
					icon: 'news',
					title: 'Bonuses & Discounts',
					uri: 'discounts/',
					shouldShow: can('viewDiscounts') && !isRocket
				},
				{
					icon: 'adv',
					title: 'Missions & Achievements',
					uri: 'missions/',
					shouldShow: can('missionsView') && !isRocket
				},
				{
					icon: 'adv',
					title: 'Goods',
					uri: 'goods/',
					shouldShow: can('viewGoods')
				},
				{
					icon: 'adv',
					title: 'BM Accounts',
					uri: 'bm-accounts/',
					shouldShow: can('viewBmAccounts')
				},
				{
					icon: 'payments',
					title: 'Point reports',
					uri: 'marketing-reports/',
					shouldShow: can('viewMarketingReports')
				},
				{
					icon: 'codes-a',
					title: 'Ranks & QUIDs',
					uri: 'ranks-points-report/',
					shouldShow: can('viewRanksPointsReport') && isRocket
				},
				{
					icon: 'codes-a',
					title: 'Banners',
					uri: 'banners/',
					shouldShow: can('banners')
				},
				{
					icon: 'codes-a',
					title: 'Popups',
					uri: 'popups/',
					shouldShow: can('popups') && isRocket
				},
				{
					icon: 'news',
					title: 'Blog',
					uri: 'blog/',
					shouldShow: can('blog') && isRocket
				},
				{
					icon: 'codes-a',
					title: 'Configs',
					uri: 'contests/',
					shouldShow: can('contestView')
				},
				{
					icon: 'codes-a',
					title: 'Promo codes',
					uri: 'promo-codes/',
					shouldShow: can('contestView')
				}
			]
		},
		{
			icon: 'campaignDomains',
			title: 'Services',
			shouldShow:
				can('viewCampaignDomains') ||
				can('viewPayoutSystems') ||
				can('viewExchangeRates') ||
				can('viewLandingSnippets') ||
				can('viewDefinedReferers') ||
				can('viewCampaigns') ||
				can('viewPrograms') ||
				can('viewWM') ||
				can('viewAdmins') ||
				can('viewFinReports') ||
				can('viewLandingReports') ||
				can('viewAffiliateReports') ||
				can('viewPromoReports') ||
				can('viewPayoutLog') ||
				can('cplRulesList') ||
				can('geoPayoutRatesList') ||
				can('approvedRejectedPayoutsList'),
			subitems: [
				{
					icon: 'domains',
					title: 'Parking domains',
					uri: 'campaign-domains/',
					shouldShow: can('viewCampaignDomains')
				},
				{
					icon: 'payments',
					title: 'Payout systems',
					uri: 'payout-systems/',
					shouldShow: can('viewPayoutSystems')
				},
				{
					icon: 'payments',
					title: 'Currency exchange',
					uri: 'exchange-rates/',
					shouldShow: can('viewExchangeRates')
				},
				{
					icon: 'codes-a',
					title: 'Landing metrics',
					uri: 'landing-snippets/',
					shouldShow: can('viewLandingSnippets')
				},
				{
					icon: 'ref',
					title: 'Referers',
					uri: 'defined-referers/',
					shouldShow: can('viewDefinedReferers')
				},
				{
					icon: 'campaigns',
					title: 'Campaigns',
					uri: 'campaigns/',
					shouldShow: can('viewCampaigns')
				},
				{
					icon: 'web-request',
					title: 'Offer location rules',
					uri: 'offer-location-rules/',
					shouldShow: can('viewPrograms')
				},
				{
					icon: 'web-request',
					title: 'Postback log',
					uri: 'postback-log/',
					shouldShow: can('viewCampaigns')
				},
				{
					icon: 'wm',
					title: 'WM',
					uri: 'wm/',
					shouldShow: can('viewWM')
				},
				{
					icon: 'admin',
					title: 'Admins',
					uri: 'admins/',
					shouldShow: can('viewAdmins')
				},
				{
					icon: 'payments',
					title: 'Fin reports',
					uri: 'fin-reports/',
					shouldShow: can('viewFinReports')
				},
				{
					icon: 'payments',
					title: 'Landing reports',
					uri: 'landing-reports/',
					shouldShow: can('viewLandingReports')
				},
				{
					icon: 'payments',
					title: 'Affiliate reports',
					uri: 'affiliate-reports/',
					shouldShow: can('viewAffiliateReports')
				},
				{
					icon: 'payments',
					title: 'Promo reports',
					uri: 'promo-reports/',
					shouldShow: can('viewPromoReports')
				},
				{
					icon: 'payments',
					title: 'Logs',
					uri: 'payout-log/',
					shouldShow: can('viewPayoutLog')
				},
				{
					icon: 'payments',
					title: 'CPL',
					uri: 'cpl-rules/',
					shouldShow: can('cplRulesList')
				},
				{
					icon: 'payments',
					title: 'Restricted geo payout rates',
					uri: 'geo-payout-rates/',
					shouldShow: can('geoPayoutRatesList')
				},
				{
					icon: 'payments',
					title: 'Approved Rejected Payouts',
					uri: 'approve-reject/',
					shouldShow: can('approvedRejectedPayoutsList')
				}
			]
		}
	];

	const showedMenuItems = menuItems.filter(entity => entity.shouldShow).map(entity => {
		if (entity.subitems) {
			entity.subitems = entity.subitems.filter(entity => entity.shouldShow);

			// if no access to uri then take the first available from list
			if (entity.uri) {
				if (!find(entity.subitems, { uri: entity.uri })) {
					const uri = get(entity.subitems, '[0].uri');

					if (uri) {
						entity.uri = uri;
					}
				}
			}
		}

		return entity;
	});

	const availableURIs = flatten(
		showedMenuItems.map(item => {
			if (item.uri) {
				return item.uri;
			} else if (item.subitems) {
				return item.subitems.map(subitem => subitem.uri);
			}
		})
	);

	const activeItem = getActiveMenuItemIndex(showedMenuItems);

	return {
		...state.root.menu,
		items: showedMenuItems,
		activeItem,
		availableURIs
	};
};

// get menu index by location path
const getActiveMenuItemIndex = menuItems => {
	const { pathname } = window.location;
	const res = [];
	const match = pathname => itemUri => {
		return pathname.startsWith(`/${itemUri}`);
	};
	const isEqualToPathname = match(pathname);
	let affiliatesMenuIdx = 0;
	menuItems.forEach((item, i) => {
		if (item.uri === 'affiliates/') affiliatesMenuIdx = i;
		if (item.uri && isEqualToPathname(item.uri)) {
			res.push(i);
		}

		if (item.subitems) {
			item.subitems.forEach((subitem, j) => {
				if (isEqualToPathname(subitem.uri)) {
					res.push(i);
					res.push(j);
				}
			});
		}
	});

	// hack for applicants
	if (!res[0]) res.push(affiliatesMenuIdx);

	return res;
};

const reduceDataToObject = data => {
	const dataKeys = keys(dataToFetch);
	return data.reduce((object, currentValue, index) => {
		object[dataKeys[index]] = currentValue;
		return object;
	}, {});
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/root/index.js